const labels = {
  FaqCategories: {
    'Ref: Page title': 'GYIK',
    'Ref: Missing Faq': 'GYIK üres',
    'Ref: Go to home page': 'Keresse meg a Kezdőlapot',
  },
  FaqCategoryDetails: { 'Ref: Page title': 'Kérdés' },
};
export default labels;
